module.exports = __webpack_public_path__ + "static/media/dragon knight.a1f85eb3.png";